import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../content";
import { Reveal } from "../hooks";

function FAQItem({ q, a, index }) {
  const [open, setOpen] = useState(false);
  return (
    <Reveal delay={index * 0.05}>
      <div className="border border-border rounded-2xl overflow-hidden">
        <button
          className="w-full flex items-center justify-between p-5 text-left font-medium font-cabinet hover:bg-muted/40 transition-colors"
          onClick={() => setOpen((o) => !o)}
        >
          {q}
          <ChevronDown
            className={`h-4 w-4 text-muted-foreground transition-transform duration-300 ${open ? "rotate-180" : ""}`}
          />
        </button>
        <div
          className={`overflow-hidden transition-all duration-300 ${open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}
        >
          <div className="px-5 pb-5 text-sm text-muted-foreground leading-relaxed font-plex">
            {a}
          </div>
        </div>
      </div>
    </Reveal>
  );
}

export function FAQSection({ faqs = FAQS }) {
  return (
    <section
      className="py-24 px-4 relative"
      data-testid="faq-section"
      style={{
        background:
          "linear-gradient(180deg, hsl(0 0% 100%) 0%, hsl(220 15% 98%) 50%, hsl(0 0% 100%) 100%)",
      }}
    >
      <div className="max-w-2xl mx-auto">
        <Reveal>
          <div className="text-center mb-12">
            <div className="text-xs font-mono font-medium text-primary uppercase tracking-widest mb-3">
              FAQ
            </div>
            <h2 className="text-3xl font-cabinet font-black tracking-tight mb-4">
              Frequently Asked Questions
            </h2>
          </div>
        </Reveal>
        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => (
            <FAQItem key={i} index={i} q={f.q} a={f.a} />
          ))}
        </div>
      </div>
    </section>
  );
}
